<template>
  <el-container>
    <el-header style="height: 35px; border-bottom: 1px solid #eee">
      <el-row type="flex" justify="space-between" align="middle">
        <el-row>
          <el-popover v-if="validItems.length" placement="bottom-start" trigger="hover" v-model="showRecordSelect">
            <!-- <el-scrollbar style="max-height: 30rem"> -->
            <el-row v-for="(row, index) in validItems" :key="row.id" :class="index ? 'top-pad' : ''" style="min-width: 12rem">
              <el-link @click="switchRecord(row)" :underline="false" icon="el-icon-collection-tag" :disabled="collection.curr && collection.curr.id == row.id">
                {{ row.name }}
              </el-link>
            </el-row>
            <!-- </el-scrollbar> -->
            <el-link slot="reference" type="primary" :underline="false" icon="el-icon-collection-tag">
              <span v-if="collection.curr">
                {{ collection.curr.name }}
              </span>
              <span v-else>共有 {{ validItems.length }} 条收藏，请选择！</span>
            </el-link>
          </el-popover>
          <el-button v-if="collection.curr" type="text" icon="el-icon-delete" size="mini" @click="removeCollection" :disabled="!collection.curr" class="danger"></el-button>
          <span v-if="!loading && !validItems.length" class="danger">收藏列表为空</span>
        </el-row>
        <el-button type="primary" size="mini" plain @click="collect">收藏左侧病历</el-button>
        <el-popover v-if="collection.curr && doc.items.length" placement="bottom-start" trigger="hover" v-model="showDocSelect">
          <el-row v-for="(item, index) in doc.items" :key="item.id" :class="index ? 'top-pad' : ''">
            <el-link :underline="false" @click="switchDoc(item)" :disabled="doc.curr && doc.curr.id == item.id">
              <el-tag v-if="item.isMissing" type="danger" size="mini" hit>缺失</el-tag>
              <i v-else class="el-icon-document" />
              {{ item.tmplCode | dictText("MrTemplate") }}
            </el-link>
          </el-row>
          <el-link type="primary" slot="reference" :underline="false">
            <span v-if="doc.curr">
              <el-tag v-if="doc.curr.isMissing" type="danger" size="mini" hit>缺失</el-tag>
              <i v-else class="el-icon-document" />
              {{ doc.curr.tmplCode | dictText("MrTemplate") }}
            </span>
            <span v-else>共有 {{ doc.items.length }} 份文书，请选择！</span>
          </el-link>
        </el-popover>

        <span v-if="!loading && collection.curr && !doc.items.length" class="danger">当前病历不含文书！</span>
      </el-row>
    </el-header>
    <el-main style="position: absolute; top: 35px; bottom: 0px; left: 0; right: 0">
      <Ide ref="ide" readonly />
    </el-main>
  </el-container>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      main: Object,
    },
    components: {
      Ide: () => import("./_ide.vue"),
    },
    data() {
      return {
        showRecordSelect: false,
        showDocSelect: false,
        loading: false,
        collection: {
          items: [],
          curr: null,
        },
        doc: {
          items: [],
          curr: null,
        },
      };
    },
    computed: {
      ...mapGetters(["user"]),
      isIp() {
        return !!this.main?.ipNo;
      },
      validItems() {
        if (!this.collection.items) {
          return [];
        }
        return this.collection.items.filter((item) => (this.isIp ? !!item.ipNo : !!item.opNo));
      },
    },
    mounted() {
      this.page();
    },
    methods: {
      page() {
        this.collection.items = [];
        this.collection.curr = null;
        // 加载收藏病历
        this.$api.Collection.query({ doctorCode: this.user.code }).then((res) => {
          this.collection.items = res.items;
        });
      },
      switchRecord(row) {
        this.closeFile();
        this.showRecordSelect = false;
        this.collection.curr = row;
        this.$api.Mr.query({ mainId: row.mainId }).then((res) => {
          this.doc.items = res.items;
          if (res.items.length) {
            this.switchDoc(res.items[0]);
          }
        });
      },
      switchDoc(item) {
        if (item.isMissing) {
          return;
        }
        this.closeFile();
        this.showDocSelect = false;
        this.doc.curr = item;
        this.$api.MrVer.view(item.id).then((res) => {
          if (!res) {
            this.$set(item, "isMissing", true);
            return;
          }
          this.$refs.ide.openFile(res.content, false, res.ifEditing);
        });
      },
      closeFile() {
        if (this.$refs.ide) this.$refs.ide.closeFile();
      },
      collect() {
        let row = {
          mainId: this.main.id,
          deptCode: this.user.deptCode,
          doctorCode: this.user.code,
          name: `${this.main.patientName}的病历${this.main.ipNo || this.main.opNo}`,
          patientName: this.main.patientName,
          ipNo: this.main.ipNo,
          opNo: this.main.opNo,
        };
        this.$prompt("请输入收藏名称<p style='color:#F56C6C;'>注：收藏病历必须提交后才能正常使用</p>", "病历收藏", {
          dangerouslyUseHTMLString: true,
          inputValue: row.name,
          inputErrorMessage: "名称不能为空！",
          inputValidator: (value) => {
            if (!value) {
              return "名称不能为空！";
            }
          },
        })
          .then(({ value }) => {
            row.name = value;
            return this.$api.Collection.save(row);
          })
          .then((res) => {
            if (!row.id) {
              this.collection.items.push(res);
            }
          })
          .catch((err) => {
            if (err != "cancel") {
              console.log(err);
            }
          });
      },
      removeCollection() {
        if (!this.collection.curr) {
          return;
        }

        this.$confirm("确定要取消当前收藏吗？", "病历收藏")
          .then((res) => {
            return this.$api.Collection.del(this.collection.curr.id);
          })
          .then((res) => {
            this.collection.items.splice(this.collection.items.indexOf(this.collection.curr), 1);
            if (row.id == this.collection.curr.id) {
              if (this.validItems.length) {
                this.switchRecord(this.validItems[0]);
              } else {
                this.collection.curr = null;
                this.closeFile();
              }
            }
          })
          .catch((err) => {
            if (err != "cancel") {
              console.log(err);
            } else {
              return;
            }
            this.collection.curr = null;
            this.closeFile();
          });
      },
    },
  };
</script>
